
import { Component, Vue } from 'vue-property-decorator'
import PasswordGuide from '@/components/templates/password/PasswordGuide.vue'

/**
 * パスワード再設定完了ページ
 */
@Component({
  components: {
    PasswordGuide,
  },
})
export default class StudentPasswordResetComplete extends Vue {
  /**
   * ログイン画面のリンク定義
   *
   * @returns 遷移先URL
   */
  private get linkUrl(): string {
    return '/student/login'
  }
}
